import { render } from "./completedContents.vue?vue&type=template&id=effb2ca4&scoped=true"
import script from "./completedContents.vue?vue&type=script&lang=js"
export * from "./completedContents.vue?vue&type=script&lang=js"

import "./completedContents.vue?vue&type=style&index=0&id=effb2ca4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effb2ca4"]])

export default __exports__